import TopNavbar from './TopNavbar.vue';
import BottomBar from './BottomBar.vue';
import DashboardContent from './Content.vue';
import Loader from '../Shared/Loader.vue';
import CONFIG_COMPANY from "../../services/myConfig";
import AdminApi from '../../services/api'
import session from "../../services/session";
import swal from "sweetalert2";

const AdminApiService = new AdminApi()


export default {
    data() {
        return {
            showOnlyProgram: false,
            role: '',
            desktopNavMode: 'sidebar'
        }
    },
    methods: {
        toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        initSugarWod() {
            if (CONFIG_COMPANY.WOD == null) return;
            window.sugarwod_options = CONFIG_COMPANY.WOD;
            var sugar = window.SugarWOD
            if (sugar == null) return;

            var canLaunch = sugar.initialize();
            if (canLaunch && sugar.options.showButton) {
                sugar.createSugarWODButton().addToBody();
            }
            if (canLaunch && sugar.options.openOnPageLoad) {
                sugar.show();
            }
        },
        refreshDesktopNavMode() {
            const mode = localStorage.getItem('DESKTOP_NAV_MODE');
            this.desktopNavMode = mode === 'topbar' ? 'topbar' : 'sidebar';
        },
        onDesktopNavModeChanged(mode) {
            this.desktopNavMode = mode === 'topbar' ? 'topbar' : 'sidebar';
        },
        getConfig: getConfig
    },
    created() {
        this.initSugarWod();
        document.title = CONFIG_COMPANY.TITLE;
        this.refreshDesktopNavMode();
        this.$topnavbar.$on('desktopNavModeChanged', this.onDesktopNavModeChanged);
    },
    destroyed() {
        this.$topnavbar.$off('desktopNavModeChanged', this.onDesktopNavModeChanged);
    },
    beforeMount() {
        this.role = session.getRole();
        this.showOnlyProgram = this.$route.query.programToken != null
        if (this.$route.query.programToken != null) {
            this.getConfig();
            session.removeWodLastDate()
            localStorage.setItem('ACCESS_TOKEN', this.$route.query.programToken);
            try {
                let decodedToken = session.parseJwt(this.$route.query.programToken);
                let authField = decodedToken.auth;
                localStorage.setItem('USER_ROLE', authField);
            } catch (e) {
                localStorage.setItem('USER_ROLE', "ROLE_USER");
            }

        }
        if (this.$route.query.locale != null) {
            session.setLocale(this.$route.query.locale)
        }
        if (session.getSelectedCompany() != null && session.getAccessToken() != null) {
            CONFIG_COMPANY.setCompany(session.getSelectedCompany())
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        isMobileAndUser() {
            if (window.innerWidth > 767 || !this.isEnableBottomBar) return true;
            return session.getRole() === 'ROLE_ADMIN' || session.getRole() === 'ROLE_SUPER_ADMIN' || session.getRole() === 'ROLE_TRAINER';
        },
        isLoggedIn() {
            return session.getAccessToken() !== null
        },
        isEnableBottomBar() {
            return CONFIG_COMPANY.IS_ENABLED_BOTTOM_BAR;
        }
    },

    components: {
        TopNavbar,
        DashboardContent,
        Loader,
        BottomBar
    }
}


function getConfig() {
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Layout/MainView.js